module.exports = __webpack_public_path__ + "./fonts/Simple-Line-Icons4c82.woff";